import axios from "axios";
import configs from "config";
import { AUTH_USER, saveItemSessionStorage } from "utils/helpers";
import { APIProductProps, ProductProps } from "./products";

export type LoginProps = {
  login: string;
  password: string;
  isp_identifier: string;
};

export type MessageProps = {
  message?: string;
  authenticated: boolean;
};

export type AuthProps = {
  companyId: number;
  user_id: string;
  token: string;
  code: number;
  message: string;
  authenticated: boolean;
  products?: ProductProps[];
};

export type APIAuthProps = {
  id_cliente: number;
  id_cliente_usuario: number;
  cod_retorno: number;
  msg_retorno: string;
  autenticado: boolean;
  produtos?: APIProductProps[];
};

const login = async (
  credentials: LoginProps
): Promise<AuthProps | MessageProps | null> => {
  try {
    const response = await axios.post(
      `${configs.baseURL}/LoginCampSoft`,
      {
        login: credentials.login,
        password: credentials.password,
        isp_identifier: credentials.isp_identifier,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response && response.data && response.data.access) {
      saveItemSessionStorage(`${AUTH_USER}_${configs.localStorageKey}`, {
        authenticated: true,
        ...response.data,
      });

      return {
        authenticated: true,
        ...response.data,
      };
    } else {
      throw Error(response.data.message);
    }
  } catch (error) {
    //@ts-ignore
    const errorMessage = error?.response?.data?.message || error?.message;

    return {
      message: errorMessage || "Internal server error",
      authenticated: false,
    };
  }
};

export { login };
